window.antifraud = {
	...window.antifraud,
	createGtagScripts: function () {
		const d = document;
		const scriptInline = d.createElement('script');
		const scriptExternal = d.createElement('script');
		const id = 'G-0VEMQ9TW1Y';

		d.head.prepend(scriptInline);
		scriptInline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${id}');`;
		d.head.prepend(scriptExternal);
		scriptExternal.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
		scriptExternal.async = true;
	}
};
